import React, { FC } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface SVGComponentProps {
    width?: number;
    height?: number;
    className?: string;
}

const CloseIcon: FC<SVGComponentProps> = ({
    width = 14,
    height = 14,
    className
}) => {
    return (
        <SVGUniqueID>
            <svg
                width={width}
                height={height}
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={className}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 0.583328C3.45617 0.583328 0.583328 3.45617 0.583328 7C0.583328 10.5438 3.45617 13.4167 7 13.4167C10.5438 13.4167 13.4167 10.5438 13.4167 7C13.4167 3.45617 10.5438 0.583328 7 0.583328ZM9.16247 4.83752C9.39028 5.06532 9.39028 5.43467 9.16247 5.66247L7.82495 7L9.16247 8.33752C9.39028 8.56532 9.39028 8.93467 9.16247 9.16247C8.93467 9.39028 8.56532 9.39028 8.33752 9.16247L7 7.82495L5.66247 9.16247C5.43467 9.39028 5.06532 9.39028 4.83752 9.16247C4.60971 8.93467 4.60971 8.56532 4.83752 8.33752L6.17504 7L4.83752 5.66247C4.60971 5.43467 4.60971 5.06532 4.83752 4.83752C5.06532 4.60971 5.43467 4.60971 5.66247 4.83752L7 6.17504L8.33752 4.83752C8.56532 4.60971 8.93467 4.60971 9.16247 4.83752Z"
                    fill="#737373"
                />
            </svg>
        </SVGUniqueID>
    );
};

export { CloseIcon };

